import Model from '@/models/Model'

export default class ADispatched extends Model {
    resource() {
        return 'dispatched'
    }
}